import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';

import { styled } from '@mui/material';

import {
  Grid,
  Button,
  Checkbox,
  TextField,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
} from '@mui/material';

import { ChangeEvent } from 'react';
import { ServerModuleType } from 'features/systemModules/type';
import { ServerLicenseForm } from './types';

const StyledGrid = styled(Grid)(
  ({ theme }) => `
  '& > *': {
    margin: ${theme.spacing(1)},
  },
`
);

interface Props {
  handleLicenseChecked: (event: ChangeEvent<HTMLInputElement>) => void;
  handleLicenseLimitChanged: (event: ChangeEvent<HTMLInputElement>) => void;
  handleCreateLicense: () => void;
  handleDemoLicenseChecked: (event: ChangeEvent<HTMLInputElement>) => void;
  handleDemoExpirationChanged: (date: any) => void;
  license: ServerLicenseForm;
  isDemoLicense: boolean;
  demoLicenseExpiration: any;
}

const CreateServerLicenseForm = ({
  license,
  isDemoLicense,
  demoLicenseExpiration,
  handleLicenseChecked,
  handleLicenseLimitChanged,
  handleCreateLicense,
  handleDemoLicenseChecked,
  handleDemoExpirationChanged,
}: Props) => {
  const checkIfModuleSelected = (moduleType: ServerModuleType) => {
    return license?.hasOwnProperty(moduleType);
  };

  return (
    <>
      <Grid item xs={12}>
        <FormControl component='fieldset'>
          <FormLabel component='legend'>Modules</FormLabel>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    checkIfModuleSelected(ServerModuleType.ADVANCED_HISTORY) ||
                    false
                  }
                  onChange={handleLicenseChecked}
                  name='ADVANCED_HISTORY'
                  disabled={!license}
                />
              }
              label='Advanced History'
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    checkIfModuleSelected(ServerModuleType.WEATHER) || false
                  }
                  onChange={handleLicenseChecked}
                  name='WEATHER'
                  disabled={!license}
                />
              }
              label='Weather'
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    checkIfModuleSelected(ServerModuleType.SWITCHES) || false
                  }
                  onChange={handleLicenseChecked}
                  name='SWITCHES'
                  disabled={!license}
                />
              }
              label='Switches'
            />
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <TextField
          name='SWITCHES'
          label='Switch Limit'
          margin='dense'
          size='small'
          type='number'
          value={license?.SWITCHES?.limit || 1}
          onChange={handleLicenseLimitChanged}
          fullWidth
          disabled={!license?.SWITCHES}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name='WEATHER'
          label='Weather Location Limit'
          margin='dense'
          size='small'
          type='number'
          value={license?.WEATHER?.limit || 1}
          onChange={handleLicenseLimitChanged}
          fullWidth
          disabled={!license?.WEATHER}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isDemoLicense}
              onChange={handleDemoLicenseChecked}
              name='demo_license'
              disabled={!license}
            />
          }
          label='Expiring License?'
        />
      </Grid>
      <Grid item xs={12}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label='Expiration Date'
            inputFormat='MM/dd/yyyy'
            value={demoLicenseExpiration}
            onChange={(date) => handleDemoExpirationChanged(date)}
            renderInput={(props) => <TextField {...props} />}
            disabled={!isDemoLicense}
          />
        </LocalizationProvider>
      </Grid>
      <StyledGrid item>
        <Button
          variant='contained'
          color='primary'
          component='span'
          onClick={handleCreateLicense}
        >
          Create License
        </Button>
      </StyledGrid>
    </>
  );
};

export default CreateServerLicenseForm;
